module.exports = __webpack_public_path__ + "img/im_scrollfeature_08.ed22c243.jpg";